/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Save_Interval_LabelInputs */



/**
* | output |
* | --- |
* | "Save Interval (minutes)" |
*
* @param {Options_Backup_Save_Interval_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_save_interval_label = /** @type {((inputs?: Options_Backup_Save_Interval_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Save_Interval_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intervalle d'enregistrement (minutes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherintervall (Minuten)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Intervallo di salvataggio (minuti)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Интервал сохранения (минуты)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Intervalo de guardado (minutos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存间隔（分钟）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存間隔（分）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेव करने का अंतराल (मिनटों में)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Intervalo de salvamento (minutos)")
	return /** @type {LocalizedString} */ ("Save Interval (minutes)")
});